export const GET_ZUORA_SIGNATURE_REQUEST = 'GET_ZUORA_SIGNATURE_REQUEST';
export const GET_ZUORA_SIGNATURE_SUCCESS = 'GET_ZUORA_SIGNATURE_SUCCESS';
export const GET_ZUORA_SIGNATURE_FAILURE = 'GET_ZUORA_SIGNATURE_FAILURE';
